import MasonryPLP from 'components/cms/blocks/product-listing/masonry-plp';
import StandardPLP from 'components/cms/blocks/product-listing/standard-plp';

function ProductListing({ block, breadcrumbs, category, categoryMenu }) {
	const productListingSlot = block.slots.find(slot => slot.type === 'product-listing');
	const isStandardPLP = productListingSlot?.config?.boxLayout?.value !== 'masonry';

	return (
		<>
			{isStandardPLP ? (
				<StandardPLP block={block} breadcrumbs={breadcrumbs} category={category} categoryMenu={categoryMenu} />
			) : (
				<MasonryPLP block={block} breadcrumbs={breadcrumbs} category={category} categoryMenu={categoryMenu} />
			)
			}
		</>
	);
}

export default ProductListing;
